import { ElementDetailsViewModel, ParameterValueViewModel } from "@/TemsManagerWebInterface";
import SiteManagerView from "@/Site/SiteManagerView";
import Localization from "@/Localization";
import CommonMethods from "@/CommonMethods";
import { ViewModelUserLevel } from 'Tems/Security/TemsPolicy';
import 'bootstrap';
import '@/jquery/x-editable';

export default class DeviceDetailsView {

    private lastElementDetails: ElementDetailsViewModel;
    private siteManagerView: SiteManagerView;
    elementDetailsWereEdited: boolean = false;
    

    constructor(siteManagerView: SiteManagerView) {
        this.siteManagerView = siteManagerView;
    }

    public showElementDetails(id: string) {
        $.getJSON("/api/ElementDetails/GetElementDetail/" + id, (elementDetails: ElementDetailsViewModel) => {
            this.lastElementDetails = elementDetails;
            var modalTitle = $("#modalElementDetails > .modal-dialog > .modal-content > .modal-header > .modal-title");
            var modalTitleInnerTitle = $("<span>", { class: 'modalDeviceDetailsTitle', 'data-type': 'text', text: `${elementDetails.Title} (${elementDetails.Type})` });

            modalTitle.html("");
            modalTitle.append(modalTitleInnerTitle);
            let tableRowPositionString = elementDetails.Position !== null ?
                `<tr>
                        <td>${Localization.resourceStrings.SiteView_ElementDetailsPosition}</td>
                        <td>x : ${elementDetails.Position[0]}, y : ${elementDetails.Position[1]}, z : ${elementDetails.Position[2]}</td>
                    </tr>` :
                "";
            let tableRowRotationString = elementDetails.Rotation !== null ?
                `<tr>
                        <td>${Localization.resourceStrings.SiteView_ElementDetailsRotation}</td>
                        <td>x : ${elementDetails.Rotation[0]}, y : ${elementDetails.Rotation[1]}, z : ${elementDetails.Rotation[2]}</td>
                    </tr>` :
                "";

            $("#tbodyGeneralElementDetails").html(
                `<tr>
                        <td>${Localization.resourceStrings.SiteView_ElementDetailsType}</td>
                        <td>${elementDetails.Type}&nbsp;<span class='label label-${Localization.translateHealth(elementDetails.Health)} element-state'>&nbsp;&nbsp;</span></td>
                    </tr>
                    <tr>
                        <td>${Localization.resourceStrings.SiteView_ModalElementDetailsDescription}</td>
                        <td>${elementDetails.Description}</td>
                    </tr>
                    ${tableRowPositionString}
                    ${tableRowRotationString}`
            );

            $("#tbodyParameterConfigs").html("");
            $("#collapseParameter").addClass("hidden");
            $("#panelElementDetailsParameter").hide();
            $("#tableParameterConfigs").html("");
            if (elementDetails.ParameterConfigs) {
                $.each(elementDetails.ParameterConfigs,
                    paramIdx => {
                        // NOTE
                        // We create a table row for each ParameterConfig, Name, Input, help
                        // For the input we create an x-editable object. 
                        //    Identify the dataType
                        //    Validation method
                        //   


                        // Create new cell containing for the row
                        var p = elementDetails.ParameterConfigs[paramIdx];
                        var parameterValue = $("<td>", {
                            'class': "deviceParameter",
                            'data-id': p.Id
                        });

                        // Determine the datatype for the x-editable element
                        let dataType: string;
                        let htmlValue: string;
                        let validationFunction: (any) => { newValue: any, msg?: string };
                        if (p.Name.match(/password/i)) {
                            dataType = "password";
                            htmlValue = "********";
                        } else {
                            if (p.Type === "int") {
                                validationFunction = newValue => {
                                    if (isNaN(parseInt(newValue))) {
                                        return {
                                            newValue: newValue,
                                            msg: 'Integer only'
                                        };
                                    }

                                    return undefined;
                                };

                                dataType = "text";
                            } else if (p.Type === "uint") {
                                validationFunction = newValue => {
                                    if (isNaN(parseInt(newValue)) || parseInt(newValue) < 0) {
                                        return {
                                            newValue: newValue,
                                            msg: 'Positive integer only'
                                        };
                                    }

                                    return undefined;
                                };

                                dataType = "text";
                            } else if (p.Type === "number") {
                                // NOTE: 
                                // Why revert to text if there is an < input  type= "number" > in html5 ? 
                                // Some browsers start throwing errors, becauses the x-editable library doesn't properly handle the case and calls the setSelectionRange function, which is not supported on number inputs.
                                dataType = "text";
                                validationFunction = newValue => {
                                    if (isNaN(Localization.parseLocaleNumber(newValue))) {
                                        return {
                                            newValue: newValue,
                                            msg: 'Only numbers allowed'
                                        };
                                    }

                                    return {
                                        newValue: Localization.formatNumberFractionDigits(Localization.parseLocaleNumber(newValue), 1)
                                    };
                                };
                            } else {
                                dataType = p.Type;
                            }

                            htmlValue = p.Value;
                        }

                        // create the cell with the current parameter value
                        // If the user is allowed to edit the parameter, setup the infos for the x-editable object
                        if (p.Writable) {
                            if (p.Type === "boolean") {
                                parameterValue.append($("<span>", {
                                    'data-type': "select",
                                    'data-source': `[{value:1,text:'${Localization.resourceStrings.SiteView_ElementDetailsSelectYes}'},{value:0,text:'${Localization.resourceStrings.SiteView_ElementDetailsSelectNo}'}]`,
                                    'data-value': p.Value === "True" ? 1 : 0,
                                    'class': "deviceParameterValue",
                                    'html': p.Value === "True" ? Localization.resourceStrings.SiteView_ElementDetailsSelectYes : Localization.resourceStrings.SiteView_ElementDetailsSelectNo
                                }));
                            } else if (p.Type === "select") {
                                parameterValue.append(DeviceDetailsView.createDataSelectionSourceDrowpdown(p.Value, p.Selection, p.AllowEmptySelection));
                            } else {
                                if (p.Type === "number") {
                                    htmlValue = Localization.formatNumberFractionDigits(Number(p.Value), 1);
                                }

                                parameterValue.append($("<span>", {
                                    'data-type': dataType,
                                    'data-value': htmlValue,
                                    'text': htmlValue,
                                    'class': "deviceParameterValue"
                                }));
                            }
                        } else {
                            // Special treatment for selections
                            let htmlValue = p.Value;
                            if (p.Selection != null) {
                                let valueOptions = $.grep(p.Selection, (parameterViewModel, idx) => parameterViewModel.Value === p.Value);
                                if (valueOptions.length > 0) {
                                    htmlValue = valueOptions[0].Title;
                                }
                            }

                            parameterValue.append($("<span>", { html: htmlValue, 'class': "deviceParameterValue" }));
                        }

                        // Combine into the actual row
                        var newRow = $("<tr>", { "class": "help" })
                            .click((event) => {
                                var elementParents = $(event.target).parentsUntil("tr").addBack();
                                if (!(elementParents.hasClass("editable") || elementParents.hasClass("editable-input") || elementParents.hasClass("editable-buttons"))) {
                                    $(`.infoSection[data-id!='${p.Id}']`).hide();
                                    $(`.infoSection[data-id='${p.Id}']`).fadeToggle("fast");
                                }
                            })
                            .append($("<td>", { 'class': "deviceParameterName", html: p.Name }))
                            .append(parameterValue);

                        // Info row that contains a detailed description of the parameter
                        var infoRow = $("<tr>", { "class": "infoSection", 'data-id': p.Id })
                            .append($("<td>", { colspan: "2", "class": "borderless help", html: `<span class="alert alert-info" style="display:block;"><span class="glyphicon glyphicon-info-sign"></span>&nbsp;${p.Description}</span>` }))
                            .click(() => { $(`.infoSection[data-id='${p.Id}']`).fadeOut("fast"); })
                            .hide();

                        // Attach to the current table
                        $("#tableParameterConfigs")
                            .append($("<tbody>", { "class": "tbodyHoverGroup" })
                                .append(newRow)
                                .append(infoRow));

                        // If the user is in edit mode, convert the parameter value into an x-editable element
                        if (this.siteManagerView.IsInEditMode) {
                            const editables = parameterValue.children("span[data-type]");
                            editables.editable({
                                success: (response, newValue) => {
                                    this.elementDetailsWereEdited = true;
                                    $("#modalElementDetails").focus(); // focusing the div, to not visually irritate the user with a focused button
                                },
                                validate: validationFunction
                            });

                            // To disable certain keyinputs during editing, we attach a keypress listener, when the input dom element is generated
                            editables.on("shown",
                                (e, editable) => {
                                    if (p.Type === "int" || p.Type === "uint") {
                                        editable.input.$input.on("keydown", (evt) => { // keydown != keypress! the keycodes between those two events are totally different
                                            CommonMethods.validateKeyInputForNumber(evt, false, p.Type === "int");
                                        });
                                    } else if (p.Type === "number") {
                                        editable.input.$input.on("keydown", (evt) => {
                                            CommonMethods.validateKeyInputForNumber(evt, true, true);
                                        });
                                    }
                                });

                            if (dataType === "password") {
                                editables.editable("setValue", p.Value); // set the value behind the scenes, to ensure the value is not html plain-text
                            }
                        }
                    }
                );

                $("#collapseParameter").removeClass("hidden");
                $("#panelElementDetailsParameter").show();
            }

            $("#tbodyStateGroups").html("");
            $("#collapseStatus").addClass("hidden");
            $("#panelElementDetailsStateGroups").hide();
            if (elementDetails.StateGroups) {
                $.each(elementDetails.StateGroups,
                    (index, s) => {
                        var newRow = `<tr>
                                            <td>${s.Name}</td>
                                            <td>${s.Value}</td>
                                            <td><span class='label label-${Localization.translateHealth(s.Health)} element-state'>&nbsp;&nbsp;</span></td>
                                          </tr>`;
                        $("#tbodyStateGroups").append(newRow);
                    });

                $("#collapseStatus").removeClass("hidden");
                $("#panelElementDetailsStateGroups").show();
            }

            $("#modalButtonClose").unbind("click");
            $("#modalButtonClose").on("click", () => { this.closeElementDetails(false); });

            $("#modalButtonSaveElementDetailChanges").unbind("click");
            $("#modalButtonSaveElementDetailChanges").on("click", () => { this.saveElementDetails(id); });

            $("#modalElementDetails").modal("show");
        });
    }

    private saveElementDetails(elementId: string): void {
        this.siteManagerView.changeUserLevel(ViewModelUserLevel.AuthorizedClient).then(() => {
            var parameterConfigs = this.lastElementDetails.ParameterConfigs;
            var unsavedChanges: boolean = false;
            var parameters = [];

            // programmatically submit it all open editable-containers
            // note that editable("submit") didn't work, don't know why..
            $(".editable-container").find("form").submit();

            // We should be able to simplify this, by taking advantage of the x-editable's feature to mark edited values; or hook in the 'success' handler which currently just sets elementDetailsWereEdited

            var rows = $("#tableParameterConfigs > tbody").children("tr");
            rows.each((index, row) => {
                if (!$(row).hasClass("infoSection")) {
                    var id: string = $(row).children(".deviceParameter").data("id");
                    var valueElement: JQuery = $(row).find(".deviceParameterValue");
                    var value: string = valueElement.hasClass("editable")
                        ? <any>(valueElement.editable("getValue", true))
                        : valueElement.text();
                    if (valueElement.hasClass("editable") && valueElement.data("type") === "select") {
                        switch (valueElement.text()) {
                            case Localization.resourceStrings.SiteView_ElementDetailsSelectYes:
                                value = "True";
                                break;
                            case Localization.resourceStrings.SiteView_ElementDetailsSelectNo:
                                value = "False";
                                break;
                        }
                    }

                    if (typeof (value) === 'number') {
                        value = (<number>value).toString();
                    }

                    for (var i = 0; i < parameterConfigs.length; i++) {
                        if (parameterConfigs[i].Id === id && parameterConfigs[i].Type === 'number') {
                            value = Localization.parseLocaleNumber(value).toString();
                        }

                        if (parameterConfigs[i].Id === id && parameterConfigs[i].Value !== value) {
                            unsavedChanges = true;
                            parameters.push({
                                Id: id,
                                Value: value
                            });
                        }
                    }
                }
            });

            var updatedConfig = {
                ElementId: elementId,
                Parameters: parameters
            };

            if (unsavedChanges) {
                $.ajax({
                    url: "/api/SiteEdit/SaveElementDetailChanges",
                    method: "POST",
                    data: updatedConfig
                }).done(() => {
                    this.elementDetailsWereEdited = false;
                    this.closeElementDetails(false);

                    this.siteManagerView.forceSiteModelUpdate();
                }).fail(err => {
                    this.siteManagerView.showAlertMessage(Localization.resourceStrings.SiteView_ErrorUpdateConfig, err.responseJSON.Message, Localization.resourceStrings.SiteView_ErrorExceptionMessageTemplate);
                });
            } else {
                this.elementDetailsWereEdited = false;
                this.closeElementDetails(false);
            }
        });
    }

    closeElementDetails(acknowledged: boolean): void {
        if (this.siteManagerView.IsInEditMode && this.elementDetailsWereEdited && !acknowledged) {
            let textBody = Localization.resourceStrings.SiteView_MessageParameterChanged;
            let textTitle = `<span class='glyphicon glyphicon-alert'></span> ${Localization.resourceStrings.SiteView_TitleUnsavedChanges}`;
            let buttonSave = {
                Text: Localization.resourceStrings.LayoutView_ButtonSave,
                ClickHandler: () => {
                    this.siteManagerView.hideAcknowledgementModal();
                    $("#modalButtonSaveElementDetailChanges").click();
                },
                Visible: true
            };
            let buttonDiscard = {
                Text: Localization.resourceStrings.LayoutView_ButtonDiscard,
                ClickHandler: () => {
                    this.siteManagerView.hideAcknowledgementModal();
                    this.elementDetailsWereEdited = false;
                    this.closeElementDetails(true);
                },
                Visible: true
            };

            this.siteManagerView.showAcknowledgementModal(textBody, textTitle, buttonSave, buttonDiscard);
        } else {
            $("#modalElementDetails").modal('hide');
        }
    }

    public static createDataSelectionSourceDrowpdown(value: string, selectionOptions: ParameterValueViewModel[], allowEmptySelection: boolean) {
        let valueOptions = $.grep(selectionOptions, (parameterViewModel, idx) => parameterViewModel.Value === value);
        return $("<span>", {
            'data-type': "select",
            'data-source': DeviceDetailsView.createDataSelectionSourceFromStringArray(selectionOptions, allowEmptySelection),
            'data-value': value,
            'class': "deviceParameterValue",
            html: valueOptions.length > 0 ? valueOptions[0].Title : value
        });
    }

    public static createDataSelectionSourceFromStringArray(selectionOptions: ParameterValueViewModel[], allowEmptySelection: boolean): string {
        let resultString = "";

        if (allowEmptySelection) {
            // create empty element to start with
            resultString += "{value:'',text:''}";
        }

        for (var i = 0; i < selectionOptions.length; i++) {
            if (resultString.length > 0) {
                resultString += ",";
            }
            resultString += `{value:'${selectionOptions[i].Value}',text:'${selectionOptions[i].Title}'}`;
        }

        return "[" + resultString + "]";
    }
}
